import { useTheme } from '@mui/material';
import React from 'react';
import { InfoCardContent } from './InfoCardContent';

export interface ExpandableHeaderCardContentProps {
  children: React.ReactNode;
}

/**
 * ExpandableHeaderCardContent renders the collapsible header details surface.
 * @param props - Details content for the expandable header section.
 * @returns A themed info card content section.
 */
export const ExpandableHeaderCardContent = ({
  children,
}: ExpandableHeaderCardContentProps) => {
  const theme = useTheme();
  return (
    <InfoCardContent
      margin="0 16px"
      borderRadius="8px"
      backgroundColor={theme.palette.navyShades?.[50]}
    >
      {children}
    </InfoCardContent>
  );
};
